<template>
    <div class="ivu-vueCurve-div" :style="domStyle" v-show="isShow">
        <!-- loading  -->
        <Col :style="loadingStyle" span="8" v-show="isloading">
            <Spin fix>
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
        </Col>
        <div v-show="isEnable" :style="enableStyle"></div>
    </div>
</template>

<style>
    .ivu-vueCurve-div {
        -webkit-transform:scale(0.8);
        position: absolute;
    }
</style>

<script>
export default {
    name : "fvRelationalLibraryCurve",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5",
            zIndex:10000
        }
        //loading样式
        this.loadingStyle = {
            position : "absolute",
            fontSize: "15px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.oldTime="";
        //如果不添加点的话，保证程序不崩溃
        if(this.store == null){
            this.store = []; 
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    mounted : function(){
        //创建曲线
        this.initOption();
        //获取曲线数据
        this.UpDateData()
    },
    data : function(){
        return {
            //组件名称
            name : "newCommunication",
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在vueCreated(创建完毕，挂载前)函数中初始化
            domStyle : {},
            data : [],
            curve : undefined,
            isDraw : false,
            //曲线线型
            linetype:"line",
            loadingStyle:"",
            isloading:true
        }
    },
    methods : {
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox)-(window.innerWidth/10/2)+ "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy)+scaleObj.titleHeight + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) +(window.innerWidth/10) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.chart.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.chart.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) +(window.innerWidth/10) + "px";
            
            //loading自适应
            this.loadingStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) +(window.innerWidth/10) + "px";
            this.loadingStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            ;
            this.curve.resize(); 
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        getCurve(){

        },
        //是否启用时间轴
        //0 是不启用  1是启用
        SetTimeAxis(value){
            this.isTimeAxis = value;
        },
        /**
         * 作用：设置时间间隔
         * 参数1:时间间隔 
         * 参数2:索引类型  0-5秒 分 时 
         */
        SetTimeInterval(value,data){
            this.timeSpaceValue = value;
            this.indexTimeType = value;
        },
        /**
         * 作用：设置开始时间
         * 参数：可能是毫秒数，也可能是时间字符串
         */
        SetStartTime(data){
            this.startTime  = new Date(data).getTime()/1000; 
        },
        /**
         * 作用：设置结束时间
         * 参数：可能是毫秒数，也可能是时间字符串
         */
        SetEndTime(data){
            this.endTime = new Date(data).getTime()/1000; 
        },
        /**
         * 作用：获取时间长度
         */
        getTimeLength(){
            if(this.indexTimeType == 0){//秒
                var time = this.timeSpaceValue * 1000
            }else if(this.indexTimeType == 1){//分
                var time = this.timeSpaceValue * 60000
            }else if(this.indexTimeType == 2){//时
                var time = this.timeSpaceValue * 3600000
            }else if(this.indexTimeType == 3){//天
                var time = this.timeSpaceValue * 86400000
            }else if(this.indexTimeType == 4){//月
                var time = this.timeSpaceValue * 86400000*30
            }else if(this.indexTimeType == 5){//年
                var time = this.timeSpaceValue * 31536000000
            }
            return (this.endTime-this.startTime)*1000/time+1;//时间长度
        },
        /**
         * 作用：加载曲线数据
         */
        async UpDateData(){
            /**
                console.log(this.curveInfo);//那个表的那个曲线
                console.log(this.isTimeAxis);//是否取用时间轴
                console.log(this.xTabName);//x轴的表名
                console.log(this.xFieldName);//x轴字段名
                console.log(this.sourceName);//name关系库连接名称
             */
            //开启加载中
            this.isloading = true;
            //查询 遍历曲线
            this.option.legend.data = [];
            this.option.color = [];
            this.option.series = [];
            for(var o=0;o<this.curveInfo.length;o++){
                if(this.isTimeAxis == 0){
                    this.sqlSrt = "SELECT "+ this.curveInfo[o].fieldName +" FROM "+this.curveInfo[o].tabName;
                }else{
                    var startTimes = this.getTimeStr(new Date(this.startTime*1000));
                    var endTimes = this.getTimeStr(new Date(this.endTime*1000));
                    this.sqlSrt = "SELECT * FROM "+this.curveInfo[o].tabName+" WHERE "+this.xFieldName+" between '"+startTimes+"' and '"+endTimes+"'" +"order by "+this.xFieldName;
                }
                this.fieldName = this.curveInfo[o].fieldName;
                this.fieColor = this.curveInfo[o].color;
                this.name = this.curveInfo[o].name;
                var result =  await this.fvSystemApi.getDataformRDB(this.sourceName,this.sqlSrt);
                if(result.recordset == undefined) return this.showCurve("未筛选回数据");
                //判断是否启用时间轴来用于筛选时间段
                if(this.isTimeAxis == 1){
                    var timelist = [];
                    //获取时间长度
                    var lenght = this.getTimeLength();
                    var time = this.getTimeInterval();
                    for(var i = 0; i<lenght;i++){
                        timelist.push(this.startTime*1000+time*i)
                    }
                    //console.log(timelist)
                    //遍历标记
                    var number = 0;
                    //存储遍历出来数据
                    this.res = [];
                    if(result.recordset.length<=lenght){
                        for(var i=0; i<result.recordset.length;i++){
                            // 减去288毫秒值是有时差 8小时
                            var xTime = new Date(result.recordset[i][this.xFieldName]).getTime()-28800000;
                            for( var k= number; k<timelist.length;k++){
                                //筛选遍历 
                                if(timelist[k] >= xTime){
                                    this.res.push(result.recordset[i]);
                                    //-1是因为break 已经执行++
                                    number = k-1;
                                    break
                                }else{
                                    this.res.push(result.recordset[i])
                                }
                            }
                        }
                    }else{
                        for(var i=0; i<timelist.length;i++){
                            for(var j= number; j<result.recordset.length;j++){
                                var xTime = new Date(result.recordset[j][this.xFieldName]).getTime()-28800000;
                                if(timelist[i] < xTime){
                                    this.res.push(result.recordset[j])
                                    //-1是因为break 已经执行++
                                    if(j ==0){
                                        number = j; 
                                    }else{
                                        number = j-1;
                                    }
                                    break
                                }
                            }
                            if(i!=this.res.length-1){
                                this.res.push(this.res[this.res.length-1])
                            }
                        }
                    }
                }else{
                    this.res = result.recordset;
                }

                var arr = [];
                for(var k in this.res[0]){
                    arr[k] = [];
                    if(k == this.fieldName){
                        this.res.forEach(el => {
                            arr[k].push(el[k])
                        });
                    }
                }
                //数据 为纵向
                for(var index in arr){
                    this.option.series.push({
                        name: this.name,
                        type: this.linetype,
                        showSymbol: false,
                        hoverAnimation: false,
                        data: arr[index]//每条曲线的数据
                    });
                }
                this.option.legend.data.push({
                    name:this.name,
                    textStyle:{color:this.fieColor}
                });
                //曲线颜色
                this.option.color.push(this.fieColor);
            }
            //判断是否开启时间轴
            if(this.isTimeAxis == 0){
                //x轴 使用 查询表
                var sql = "SELECT "+ this.xFieldName +" FROM "+this.xTabName;
                var res = await this.fvSystemApi.getDataformRDB(this.sourceName,sql);
                this.option.xAxis.data = [];
                for(var i = 0;i<res.recordset.length;i++){
                    this.option.xAxis.data.push(res.recordset[i][this.xFieldName]);
                }
                this.showCurve();
                
            }else{
                //x轴 使用时间轴 
                this.option.xAxis.data = [];
                //获取时间长度
                var lenght = this.getTimeLength();
                var time = this.getTimeInterval();
                for(var i = 0; i<lenght;i++){
                    this.option.xAxis.data.push(new Date(this.startTime*1000+time*i).toLocaleString())
                }
                this.showCurve();
            }
            this.isloading = false;
        },
        //获取时间字符串
        getTimeStr(date){
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if(month<10){
                month="0"+month;
            }
            var dates = date.getDate();
            if(dates<10){
                dates="0"+dates;
            }
            var hours = date.getHours();
            if(hours<10){
                hours="0"+hours;
            }
            var minutes = date.getMinutes();
            if(minutes<10){
                minutes="0"+minutes;
            }
            var seconds = date.getSeconds();
            if(seconds<10){
                seconds="0"+seconds;
            }
            return year+"-"+month+"-"+dates+" "+hours+":"+minutes+":"+seconds;;
        },
        //获取时间间隔
        //返回值毫秒
        getTimeInterval(){
            if(this.indexTimeType == 0){//秒
                var time = this.timeSpaceValue * 1000
            }else if(this.indexTimeType == 1){//分
                var time = this.timeSpaceValue * 60000
            }else if(this.indexTimeType == 2){//时
                var time = this.timeSpaceValue * 3600000
            }else if(this.indexTimeType == 3){//天
                var time = this.timeSpaceValue * 86400000
            }else if(this.indexTimeType == 4){//月
                var time = this.timeSpaceValue * 86400000*30
            }else if(this.indexTimeType == 5){//年
                var time = this.timeSpaceValue * 31536000000
            }
            return time;
        },
        /**
         * 作用：展示曲线
         */
        showCurve(data){
            if(data){
                this.$Message.error(data);
                this.isloading = false;
            }
            this.curve.setOption(this.option,true);
            this.curve.resize();
        },
        /**
         * 作用：初始化曲线
         */
        initOption(){
            this.fontColor = this.fontColor? this.fontColor:"#000";
            this.backColor = this.backColor? this.backColor:"#fff";
            this.transparent = this.transparent? true:this.transparent;
            if(this.transparent){
                var backColor = "rgba(128, 128, 128,0)";
            }else{
                var backColor = this.backColor;
            }
            this.option = {
                backgroundColor: backColor,//设置背景色 curveBackgroundColor
                // title: {
                //     text: this.fvSystemApi.getResource("关系库曲线") || '关系库曲线',
                //     left:'center'
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data:[],
                    orient:'vertical',
                    right: 0,
                    top:25,
                    textStyle:{
                        fontSize:10
                    },
                    selected: {}
                },
                grid: {
                    left: '3%',
                    right: '8%',
                    bottom: '8%',
                    containLabel: true
                },
                dataZoom: [{
                    type: 'inside',
                }, {
                    show: false,
                    start: 0,
                    end: 10
                }],
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color:this.fontColor//设置x轴的颜色 
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color:this.fontColor//设置x轴的颜色 
                        }
                    },
                },
                series: []
            };
            this.chart = document.createElement("div");
            this.chart.style.width  = this.width.toString() + "px";
            this.chart.style.height = this.height.toString() + "px";
            this.chart.style.position = "absolute";
            this.chart.style.zIndex = 9999;
            this.$el.title="";
            this.$el.appendChild(this.chart);
            this.curve = this.$echarts.init(this.chart);  
            this.showCurve();
        },
        //设置组件整体显隐
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        //设置组件是否可用 0 为不可操作
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        }, 
        /**
         * 作用：打印
         */
        Print:function(){
            var system ={};
            var p = navigator.platform;
            system.win = p.indexOf("Win") == 0;
            system.mac = p.indexOf("Mac") == 0;
            system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
            if(system.win||system.mac||system.xll){
                var addWindow = window.open('','width=100%,height=100%');
                var canvas = this.domNode.getElementsByTagName("canvas");
                var img = this.$el.children[0].childNodes[0].firstChild.toDataURL("image/png");
                addWindow.document.body.innerHTML = '<img src="'+img+'"/>';
                setTimeout(function(){//避开异步问题
                    addWindow.print();
                    addWindow.close();
                }.bind(this),500);
            }else{
                alert("手机浏览器暂不支持打印操作");
            }
        }
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvRelationalLibraryCurve/fvRelationalLibraryCurve.vue